import { useEffect } from "react"
import { TableHeader, TableRow as TableRowType } from "./types"
import appInsightsLogger from "../../../logging/appInsightsLogger"

export const useValidateTableData = ({
  headers,
  rows,
  headerGroups,
}: {
  headers: TableHeader[]
  rows: TableRowType[]
  headerGroups?: string[]
}) => {
  useEffect(() => {
    if (headers.length === 0) {
      appInsightsLogger.traceError("TableV2: Headers cannot be empty")
    }
    rows.forEach((row, rowIndex) => {
      if (row.data.cells.length !== headers.length) {
        appInsightsLogger.traceError(
          `TableV2: Row ${rowIndex} has ${row.data.cells.length} cells but there are ${headers.length} headers`,
        )
      }
      row.data.cells.forEach((cell, columnIndex) => {
        const headerType = headers[columnIndex].type
        const isWrongType = (value: unknown) =>
          value !== null &&
          value !== undefined &&
          value !== "" &&
          ((headerType === "isoDateString" && typeof value !== "string") ||
            (headerType !== "isoDateString" && headerType !== typeof value))

        if (isWrongType(cell.value)) {
          appInsightsLogger.traceError(
            `TableV2: Cell at row ${rowIndex}, column ${columnIndex} should be a ${headerType} but got ${typeof cell.value}`,
          )
        }
        if (isWrongType(cell.sortValue)) {
          appInsightsLogger.traceError(
            `TableV2: Cell sortValue at row ${rowIndex}, column ${columnIndex} should be a ${headerType} but got ${typeof cell.sortValue}`,
          )
        }
      })
    })
    if (headerGroups && headerGroups.length !== headers.length) {
      appInsightsLogger.traceError(
        `TableV2: There are ${headerGroups.length} header groups but only ${headers.length} headers`,
      )
    }
    const rowIds = new Set()
    rows.forEach((row, rowIndex) => {
      if (rowIds.has(row.data.id)) {
        appInsightsLogger.traceError(
          `TableV2: Row ${rowIndex} has a duplicate id of ${row.data.id}`,
        )
      } else {
        rowIds.add(row.data.id)
      }
      const cellIds = new Set()
      row.data.cells.forEach((cell, cellIndex) => {
        if (cellIds.has(cell.id)) {
          appInsightsLogger.traceError(
            `TableV2: Cell at row ${rowIndex}, column ${cellIndex} has a duplicate id of ${cell.id}`,
          )
        } else {
          cellIds.add(cell.id)
        }
      })
    })
  }, [headerGroups, headers, rows])
}
